module.exports = __webpack_public_path__ + "static/img/completepayment__main.b939d034.svg";